import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
FLAG_GETTING_SALES_TAXES,
  GET_SALES_TAXES,
  CLEAR_SALES_TAXES,
  FLAG_GETTING_SALES_TAX,
  GET_SALES_TAX,
  CLEAR_SALES_TAX,
} from '../types';
import { SALES_TAX_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { SALES_TAX_PATH } from '../../config/paths';

const flagGettingSalesTaxes = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_SALES_TAXES,
    payload: flag,
  });

const getSalesTaxes = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingSalesTaxes(true));
    const query = tableFilters;
    const url = `${SALES_TAX_ENDPOINT}?${QueryString.stringify(query)}`;
    const response = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(response, null, dispatch);
    const salesTaxes = await response.json();
    dispatch({
      type: GET_SALES_TAXES,
      payload: salesTaxes,
    });
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagGettingSalesTaxes(false));
  }
};

const clearSalesTaxes = () => (dispatch) =>
  dispatch({
    type: CLEAR_SALES_TAXES,
  });

const flagGettingSalesTax = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_SALES_TAX,
    payload: flag,
  });

const getSalesTax =
  async ({ salesTaxId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSalesTax(true));
      const url = `${SALES_TAX_ENDPOINT}/${salesTaxId}`;
      const response = await fetch(url, { ...DEFAULT_GET_CONFIG });
      await isErrorResponse(response, null, dispatch);
      const salesTax = await response.json();
      dispatch({
        type: GET_SALES_TAX,
        payload: salesTax,
      });
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingSalesTax(false));
    }
  };

const clearSalesTax = () => (dispatch) =>
  dispatch({
    type: CLEAR_SALES_TAX,
  });

const postSalesTax =
  async ({ countryId, taxRate }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSalesTax(true));
      const payload = {
        countryId, taxRate
      };
      const url = SALES_TAX_ENDPOINT;
      const response = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const salesTax = await response.json();
      dispatch(push(`${SALES_TAX_PATH}/${salesTax.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingSalesTax(false));
    }
  };

const putSalesTax =
  async (salesTaxId, { countryId, taxRate }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSalesTax(true));
      const payload = {
        id: salesTaxId,
        countryId, taxRate
      };
      const url = `${SALES_TAX_ENDPOINT}/${salesTaxId}`;
      const response = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(response, null, dispatch);
      const salesTax = await response.json();
      dispatch(push(`${SALES_TAX_PATH}/${salesTax.id}`));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingSalesTax(false));
    }
  };

const deleteSalesTax =
  async ({ salesTaxId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingSalesTax(true));
      const url = `${SALES_TAX_ENDPOINT}/${salesTaxId}`;
      const response = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(response, null, dispatch);
      await response;
      dispatch(push(SALES_TAX_PATH));
    } catch (error) {
      toastr.error('Error', error.message);
    } finally {
      dispatch(flagGettingSalesTax(false));
    }
  };

export {
  getSalesTaxes,
  clearSalesTaxes,
  getSalesTax,
  postSalesTax,
  putSalesTax,
  clearSalesTax,
  deleteSalesTax,
};
